var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 40",
    style: {
      enableBackground: "new 0 0 60 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.backspace-refrect{opacity:0;}\r\n\t.backspace-st1{fill:#808080;}\r\n\t.backspace-st2{fill:none;stroke:#808080;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "backspace-refrect"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "backspace-st1",
    width: 60,
    height: 40
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "backspace-st1",
    d: "M57,9c0.6,0,1,0.4,1,1v20c0,0.6-0.4,1-1,1H16.8c-0.3,0-0.5-0.1-0.7-0.3L5.4,20L16.1,9.3 C16.3,9.1,16.6,9,16.8,9H57 M57,8H16.8c-0.5,0-1,0.2-1.4,0.6L4,20l11.4,11.4c0.4,0.4,0.9,0.6,1.4,0.6H57c1.1,0,2-0.9,2-2V10 C59,8.9,58.1,8,57,8L57,8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "backspace-st2",
    x1: 29.5,
    y1: 13.5,
    x2: 42.5,
    y2: 26.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "backspace-st2",
    x1: 42.5,
    y1: 13.5,
    x2: 29.5,
    y2: 26.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.ee567964.svg";
export { ForwardRef as ReactComponent };